import { useToast } from "vue-toastification";

function normalizeMessage(err) {
  // direct strings
  if (typeof err === "string") {
    return err.trim() || "Unexpected error";
  }

  // helpers
  const get = (o, p, d) =>
    p.split(".").reduce((a, k) => (a && a[k] !== undefined ? a[k] : d), o);

  if (err && typeof err === "object") {
    const status = get(err, "response.status");
    const statusText = get(err, "response.statusText");
    const code = get(err, "response.data.code") || err.code; // server code or generic code
    const responseData = get(err, "response.data");
    const dataMsg =
      get(err, "response.data.message") ??
      get(err, "response.data.error") ??
      get(err, "response.data.title");
    const validationMessage = Array.isArray(responseData)
      ? [
          ...new Set(
            responseData
              .map((item) => item?.msg)
              .filter((message) => typeof message === "string" && message.trim()),
          ),
        ].join(" ")
      : null;

    // --- Auth-aware messages ---
    if (status === 401) {
      // Map known codes to friendly text
      const CODE_MESSAGES = {
        TOKEN_EXPIRED: "Your session has expired. Please sign in again.",
        TOKEN_INVALID: "Your session is invalid. Please sign in again.",
        TOKEN_VERIFY_FAILED:
          "We couldn't verify your session. Please sign in again.",
        TOKEN_MISSING: "You're not signed in. Please sign in.",
        PK_CLAIM_MISSING: "Session is malformed. Please sign in again.",
      };
      // Prefer server-provided message if present; otherwise map by code; otherwise generic
      if (typeof dataMsg === "string" && dataMsg.trim()) return dataMsg;
      if (code && CODE_MESSAGES[code]) return CODE_MESSAGES[code];
      return "Unauthorized. Please sign in.";
    }

    // 403 forbidden (often permission issue)
    if (status === 403) {
      if (typeof dataMsg === "string" && dataMsg.trim()) return dataMsg;
      return "You don’t have permission to perform this action.";
    }

    // Network / timeout (Axios)
    if (code === "ECONNABORTED") return "Request timed out. Please try again.";
    if (!err.response && err.request)
      return "Network error. The server is unreachable.";

    // Generic API-provided message
    if (validationMessage) return validationMessage;
    if (typeof dataMsg === "string" && dataMsg.trim()) return dataMsg;

    // Generic JS error message
    if (typeof err.message === "string" && err.message.trim())
      return err.message;

    // Fallback to status line
    if (status || statusText) {
      return `${status ?? ""} ${statusText ?? "Request failed"}`.trim();
    }
  }

  return "Unexpected error";
}

const toast = useToast();

export function notifySuccess(message) {
  toast.success(message);
}

export function notifyError(errorOrMessage) {
  const message = normalizeMessage(errorOrMessage);
  toast.error(message);
}

export function notifyWarning(message) {
  toast.warning(message);
}

export function notifyInfo(message) {
  toast.info(message);
}
